import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { getApiBaseUrl } from '../../apiBase';

export default function CountryRequestModal({ open, onClose }) {
    const { t } = useTranslation(['orgSettings', 'common']);
    const [countryName, setCountryName] = useState('');
    const [currency, setCurrency] = useState('');
    const [vatRates, setVatRates] = useState('');
    const [sending, setSending] = useState(false);
    const [done, setDone] = useState(false);

    if (!open) return null;

    async function submit(e) {
        e.preventDefault();
        setSending(true);
        try {
            const token = localStorage.getItem('token');
            await axios.post(
                `${getApiBaseUrl()}/platform/country-request`,
                { countryName, currency, vatRates },
                { headers: { Authorization: `Bearer ${token}` } },
            );
            setDone(true);
        } catch {
            alert(t('orgSettings:loadError'));
        }
        setSending(false);
    }

    return (
        <div className="sp-modal-overlay" onClick={onClose} role="presentation">
            <div className="sp-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 420 }}>
                <h3 style={{ margin: '0 0 16px' }}>{t('orgSettings:countryRequest')}</h3>
                {done ? (
                    <p>{t('orgSettings:countryRequestSent')}</p>
                ) : (
                    <form onSubmit={submit}>
                        <div style={{ marginBottom: 12 }}>
                            <label className="sp-label">{t('orgSettings:region.country')}</label>
                            <input className="sp-input" value={countryName} onChange={e => setCountryName(e.target.value)} required />
                        </div>
                        <div style={{ marginBottom: 12 }}>
                            <label className="sp-label">{t('orgSettings:region.currency')}</label>
                            <input className="sp-input" value={currency} onChange={e => setCurrency(e.target.value)} placeholder="USD" />
                        </div>
                        <div style={{ marginBottom: 16 }}>
                            <label className="sp-label">{t('orgSettings:taxes.vatRate')}</label>
                            <input className="sp-input" value={vatRates} onChange={e => setVatRates(e.target.value)} placeholder="0, 10, 20" />
                        </div>
                        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                            <button type="button" className="sp-btn sp-btn--ghost" onClick={onClose}>{t('common:cancel')}</button>
                            <button type="submit" className="sp-btn sp-btn--primary" disabled={sending}>
                                {sending ? t('common:loading') : t('common:save')}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
